module.exports = __webpack_public_path__ + "static/media/Logo.8f0b6e16.svg";